import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { entityLikeSchema, entityLikeSchemaUuid } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';
import { DocumentFileTemplateTypeEnum } from '@zaoblako/shared/modules/catalog/enums/document-file-template-type.enum';
import { DocumentFileTemplateTypeEnumI18n } from '@zaoblako/shared/modules/catalog/i18n/document-file-template-type-enum.i18n';
import type { OnlyIdRequiredInterface } from '@zaoblako/shared/common/interfaces/only-id-required.interface';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import type { FileFindInterface } from '@zaoblako/shared/modules/storage/dtos/file/file-find.dto';

import * as yup from 'yup';

/** Document file template create/update API request body - DTO signature */
export interface DocumentFileTemplateFormInterface {
  /** Name this document file template */
  name: string;
  /** Document fule template type */
  type: DocumentFileTemplateTypeEnum;
  /** User who created this document file template */
  createdBy: OnlyIdRequiredInterface<UserFindInterface>;
  /** File this document file template belongs to */
  file: OnlyIdRequiredInterface<FileFindInterface>;
}

/** Document file template create/update API request body - DTO schema */
export const DocumentFileTemplateFormDto = SerdeDtoClass.create<DocumentFileTemplateFormInterface>(CatalogDtosKeysEnum.DOCUMENT_FILE_TEMPLATE_FORM_DTO, {
  name: {
    label: 'Имя',
    serializer: yup.string(),
  },
  type: {
    sortable: true,
    label: 'Тип шаблона',
    serializer: commonEnumValidator(DocumentFileTemplateTypeEnum, DocumentFileTemplateTypeEnumI18n),
  },
  createdBy: {
    sortable: true,
    label: 'Пользователь',
    serializer: entityLikeSchema,
  },
  file: {
    label: 'Файл шаблона',
    serializer: entityLikeSchemaUuid,
  },
});
